var map = {
	"./en.json": "bb69",
	"./es.json": "bf60",
	"./fr.json": "f96c3",
	"./id.json": "6a3b",
	"./ja.json": "c240",
	"./ko.json": "1922",
	"./ru.json": "33d2",
	"./tr.json": "4582",
	"./uk.json": "d5c2",
	"./vi.json": "1e58",
	"./zh-cn.json": "7cba",
	"./zh-tw.json": "0670"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2500";